import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { MEDIA } from "@/lib/media";
import { trackCompleteRegistration } from "@/lib/pixel";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash.replace(/^#/, "");
    const sid = new URLSearchParams(hash).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sid } });
        if (data?.new_user) trackCompleteRegistration({ method: "google" });
        await refresh();
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/account", { replace: true });
      } catch (err) {
        console.warn("Google sign-in callback failed", err);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#FFF9EE] gap-4">
      <img src={MEDIA.logoArc} alt="The Happy Bulldog Co." className="h-24 w-auto" />
      <Loader2 className="w-8 h-8 text-[#FF6B9D] animate-spin" />
      <p className="font-display font-semibold text-[#19324A]">Letting you in… 🐾</p>
    </div>
  );
}
